export const DEFAULT_DECIMALS = 6 // USDC

export const USDC_IBC_ON_JOLTIFY = 'ibc/65D0BEC6DAD96C7F5043D1E54E54B6BB5D5B3AEC3FF6CEBB75B9E059F3580EA3'